import { logger } from '@src/lib/logger';
import {
  X_THERAME_API_VERSION,
  X_THERAME_CALL_SESSION,
  X_THERAME_CAREGIVER_ID,
  X_THERAME_OFFICE_ID,
} from '@therame/shared';
import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_ROOT as string;

const axiosIns = axios.create({
  baseURL: baseUrl,
  headers: {
    [X_THERAME_API_VERSION]: '1',
  },
});

logger.info({ msg: 'API URL', baseUrl });

export const setAxiosAuthHeader = (token: string) => {
  axiosIns.defaults.headers.common.Authorization = 'Bearer ' + token;
};

/** The Active office never changes without a reload, so a default header will do (#1822). */
export const setAxiosOfficeHeader = (officeId: string) => {
  axiosIns.defaults.headers.common[X_THERAME_OFFICE_ID] = officeId;
};

/** Nor does the caregiver entry the tab acts through (#1841). */
export const setAxiosCaregiverHeader = (caregiverId: string) => {
  axiosIns.defaults.headers.common[X_THERAME_CAREGIVER_ID] = caregiverId;
};

/** A TAN tab's call token (#1856): fixed for the tab's life, never with a bearer. */
export const setAxiosCallSessionHeader = (token: string) => {
  axiosIns.defaults.headers.common[X_THERAME_CALL_SESSION] = token;
};

export default axiosIns;
